import React from 'react'
import { Row, Col } from "reactstrap";

export default function DisplayTextHeaderAndValueInFronSystems({ headerText, valueText }) {
    return (
        <Row>
            <Col xs={6} sm={6} md={6} lg={4} xl={4}>
            <p className="text-in-card-detail-user-log-by-nile"> {headerText} </p>
            </Col>
            <Col xs={6} sm={6} md={6} lg={8} xl={8}>
            <p className="text-in-card-detail-user-log-by-nile"> {valueText} </p>
            </Col>
        </Row>
    )
}
